<div
  class="logout-container"
  [ngStyle]="{
    'background-image': publicPageSettings && publicPageSettings.backgroungImage ? 'url(' + publicPageSettings.backgroungImage + ')' : '',
  }"
  >
  <div class="modal-logout mat-elevation-z24">
    <div class="modal-logout-message">
      @if (headerImage) {
        <img class="brand-logo" [src]="transform(headerImage)" [alt]="'accessibility_alt_brand_logo_img' | translate" />
      }
      <app-alert status="success" [message]="'logout_message_success' | translate"></app-alert>
      <a [routerLink]="['auth/login']" class="text-button">
        {{ 'login_back_to_login_form' | translate }}
      </a>
    </div>
  </div>

  <div
    class="footer"
    [ngStyle]="{
      'background-color': publicPageSettings && publicPageSettings.footerBackgroundColor ? publicPageSettings.footerBackgroundColor : '',
    }"
    >
    @if (publicPageSettings) {
      <span
      [ngStyle]="{
        color: publicPageSettings && publicPageSettings.footerFontColor ? publicPageSettings.footerFontColor : '',
      }"
        >{{ publicPageSettings?.footerText }}
        <a
          [href]="publicPageSettings.footerLink"
        [ngStyle]="{
          color: publicPageSettings && publicPageSettings.footerLinkColor ? publicPageSettings.footerLinkColor : '',
        }"
          >{{ publicPageSettings?.footerLinkText }}</a
          >
          {{ publicPageSettings?.footerCopyright }}
        </span>
      }
    </div>
  </div>
